import React from "react";
import { useQuickSightEKS  } from "@/hooks/useEKSReports";

const QuickSightAwsEKSDashboard = () => {
  const { embedUrl } = useQuickSightEKS ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsEKSDashboard;
